import React from "react";
import { Link } from "react-router";

import { css } from "@emotion/react";

import { CSS_COLORS } from "../../styles/styles-css-variables";
import { SwarovskiOptikSegmentShort } from "@swo/shared";
import { SwarovskiOptikLocaleFrontend, type TranslatedValue } from "@swo/storefront";
import { CSS_MQ } from "../../styles/breakpoints";
import { SegmentIconSvg } from "../DealerLocatorComponent/subcomponents/segment-icons";
import { SwarovskiLink } from "../_shared-components/ui-elements/SwarovskiLink";
import { GTMClassHooks } from "../../domain/google-tag-manager/GoogleTagManagerIntegration";
import { DealerDto } from "@swo/salesforce-service";
import { fontSize } from "../../styles/fonts";
import { T } from "../T";

export const SegmentElement = (props: {
  segment: SwarovskiOptikSegmentShort & { link: string; label: TranslatedValue };
  locale: SwarovskiOptikLocaleFrontend;
  onClick: () => void;
}) => {
  return (
    <SwarovskiLink
      scrollToTop={true}
      isInternal={true}
      link={props.segment.link}
      className={GTMClassHooks.segmentPickerOverlayValue(props.segment.key)}
      attachStyles={css`
        display: flex;
        flex-direction: column;
        align-items: center;

        text-decoration: none;
        cursor: pointer;

        color: ${CSS_COLORS.White};

        &:hover {
          span {
            text-decoration: underline;
          }
        }
      `}
      onClick={props.onClick}
    >
      <div
        css={css`
          width: 75px;
          height: 75px;

          ${CSS_MQ.atLeastMd} {
            width: 100px;
            height: 100px;
          }

          ${CSS_MQ.atLeastLg} {
            width: 125px;
            height: 125px;
          }

          svg {
            width: 100%;
            height: 100%;

            ${CSS_MQ.atLeastMd} {
              stroke-width: 0.6;
            }
          }
        `}
      >
        <SegmentIconSvg segment={props.segment.key as NonNullable<DealerDto["segment"]>} cropped={true} />
      </div>
      <span
        css={[
          fontSize.x2,
          css`
            text-transform: uppercase;
            color: ${CSS_COLORS.White};
          `,
        ]}
      >
        <T>{props.segment.label}</T>
      </span>
    </SwarovskiLink>
  );
};
